import React, { useRef, useState } from "react";
import { Badge, Form, OverlayTrigger, Popover, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { saveLogisticsNotes, updateLogisticsLoad } from "../../actions/logistics";
import { setLoadQueueNotes } from "../../actions/load";
import { Icon } from "../widgets";
import notesAdd from "../../../assets/images/notes.svg";

const MAX_NOTES_LENGTH = 280;

export const LogisticsNotePopup = ({ load, isQueue }) => {
	const [show, setShow] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [notes, setNotes] = useState('');
	const [isEdit, setIsEdit] = useState(false);
	const inputRef = useRef(null);

	const dispatch = useDispatch();
	const isCreate = Boolean(load.notes);
	const handleClose = () => setShow(false);

	const handleSave = () => {
		setIsSaving(true);
		handleClose();
		const params = { load_activity_uuid: load.load_activity_uuid, notes };
		dispatch(saveLogisticsNotes(params, isSaved => {
			if (isSaved) {
				if (isQueue) {
					dispatch(setLoadQueueNotes(load, { notes: notes }));
				} else {
					dispatch(updateLogisticsLoad(load.load_activity_uuid, { notes }))
				}
				setIsSaving(false);
			}
		}, false));
	}

	const handleEnter = () => {
		setNotes(load.notes || '');
		setIsEdit(!isCreate);
	}

	const handleEdit = () => {
		setIsEdit(true)
		inputRef.current.focus();
	}

	const popover = (
		<Popover id="load-history-notes-popover" className="load-history-notes-popover">
			<Popover.Title as="h3">
				<div className="notes-title">
					<span>Notes</span>
					<div className="notes-title-icons">
						{!isEdit ? (
							<span onClick={handleEdit}>
								<Icon className="fa fa-pencil m-2 cursor-pointer" />
							</span>
						) : (<>
							<span onClick={handleSave}>
								{isSaving ?
									<Spinner className="notes-loader" animation="border" />
									: <Icon className="fa fa-check m-2 cursor-pointer" />
								}
							</span>
						</>
						)}
						<span onClick={handleClose}>
							<Icon className="fa fa-times m-2 cursor-pointer" />
						</span>
					</div>

				</div>

			</Popover.Title>
			<Popover.Content>
				<div className="notes-content">
					<Form.Control
						as="textarea"
						rows={3}
						maxLength={MAX_NOTES_LENGTH}
						ref={inputRef}
						autoFocus={!isCreate}
						readOnly={!isEdit}
						className={`notes-text-input ${!isEdit && 'not-editable'}`}
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
					/>
					{isEdit && <Badge variant="light" className="notes-badge">{notes.length}/{MAX_NOTES_LENGTH}</Badge>}
				</div>
			</Popover.Content>
		</Popover>
	);

	return (
		<div className="load-history-notes line-height-none" onClick={(e) => e.stopPropagation()}>
			{isSaving ?
				<Spinner className="notes-loader" animation="border" /> : (
					<OverlayTrigger
						show={show}
						onToggle={(toggle) => setShow(toggle)}
						onExited={() => setIsEdit(false)}
						onEnter={handleEnter}
						trigger="click"
						placement="left"
						overlay={popover}
					>
						<span>
							{isCreate ?
								<Icon className="fa fa-info p-1 cursor-pointer" /> :
								isQueue ? <img className="cursor-pointer" src={notesAdd} title="Add Note" alt="Add Note" /> :
									<Icon className="fa fa-plus p-1 cursor-pointer" />}
						</span>
					</OverlayTrigger>
				)}
		</div>
	);
};
